import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MultiSelectGradeList from './MultiSelectGrade/MultiSelectGradeList';
import TreeFilterList from './/Tree/TreeFilterList';
import styles from './FilterByType.module.less';
import { SvgIcon } from 'edcom-ui';
import clsx from 'clsx';

const FilterByType = ({
  filterObject,
  onClick,
  gradeFilterName,
  contentRequestInProcess,
  selectedCategory,
}) => {
  if (!filterObject.attributes || !filterObject.anyContent) {
    return null;
  }

  const LEVEL1_LEVEL2_CATEGORY_TEXT = [
    'root',
    'Math',
    'English Language Arts',
    'Science',
    'Social Studies',
    'Foreign Language',
  ];

  const showLessAttributesDefault = LEVEL1_LEVEL2_CATEGORY_TEXT.includes(
    selectedCategory
  );

  const [isFilterExpanded, setIsFilterExpanded] = useState(true);

  const [showLessAttributes, setShowLessAttributes] = useState(
    showLessAttributesDefault
  );

  useEffect(() => {
    setShowLessAttributes(showLessAttributesDefault);
    setIsFilterExpanded(true);
  }, [selectedCategory]);

  const visibleAttributesArray = filterObject.attributes.filter(
    filter => filter.count > 0
  );
  const hasNoSelectedAttributes =
    visibleAttributesArray.filter(filter => filter.selected).length === 0;

  const onClickExpand = () => {
    if (isFilterExpanded) {
      setIsFilterExpanded(false);
      setShowLessAttributes(true);
    } else setIsFilterExpanded(true);
  };
  const onClickSeeMoreAattributes = () => {
    setShowLessAttributes(false);
  };

  let filterGroup;

  switch (filterObject.name) {
    case gradeFilterName:
      filterGroup = (
        <MultiSelectGradeList
          filterObject={filterObject}
          onClick={onClick}
          contentRequestInProcess={contentRequestInProcess}
        />
      );
      break;
    default:
      filterGroup = (
        <TreeFilterList
          filtersArray={filterObject.attributes}
          onClick={onClick}
          topLevel
          group={filterObject.name}
          contentRequestInProcess={contentRequestInProcess}
          isFilterExpanded={isFilterExpanded}
          showLessAttributes={
            visibleAttributesArray.length > 8 &&
            hasNoSelectedAttributes &&
            showLessAttributes
          }
        />
      );
  }

  return (
    <>
      <li className={styles.section}>
        {filterObject.anyContent &&
          (filterObject.name === gradeFilterName ? (
            <h4 className={styles.title}>Grade Level</h4>
          ) : (
            <button
              onClick={onClickExpand}
              className={styles.filterDropdownButton}
              aria-label={`${filterObject.name} filters`}
              aria-expanded={isFilterExpanded}
            >
              <div className={styles.filterTitleWrapper}>
                <h4 className={styles.title}>{filterObject.name}</h4>
                <SvgIcon
                  name="angleBottom"
                  className={clsx(
                    styles.chevron,
                    isFilterExpanded && styles.inverted
                  )}
                  aria-hidden
                />
              </div>
            </button>
          ))}

        {filterGroup}
      </li>

      {filterObject.name !== gradeFilterName &&
        visibleAttributesArray.length > 8 &&
        hasNoSelectedAttributes &&
        showLessAttributes &&
        isFilterExpanded && (
          <button
            onClick={onClickSeeMoreAattributes}
            className={clsx(
              styles.filterDropdownButton,
              styles.seeMoreAttributesButton
            )}
            aria-label="See more Resource Type filters"
            aria-expanded={!showLessAttributes}
          >
            <p className={styles.seeMoreText}>See more</p>
            <SvgIcon
              name="angleBottom"
              className={styles.chevron}
              aria-hidden
            />
          </button>
        )}

      <div className={styles.borderBottom} />
    </>
  );
};

export default FilterByType;

FilterByType.propTypes = {
  filterObject: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  gradeFilterName: PropTypes.string.isRequired,
  contentRequestInProcess: PropTypes.bool.isRequired,
  selectedCategory: PropTypes.string.isRequired,
};
